<section class="container">
  @if (block().title; as title) {
    <h2 class="h3 mb-3 mb-lg-4" [class.sr-only]="block().locations?.length === 1">{{ title }}</h2>
  }

  @if (block().locations) {
    <div class="row gutter-y-3 gutter-y-lg-5" [class.has--featured]="!!featuredLocation()" [class.location-grid]="isGrid()">
      @if (featuredLocation(); as location) {
        <article class="col-lg-8 featured-location text-bg-primary py-lg-4 mb-4 mb-lg-0">
          <app-location-card class="position-relative z-2" [class.card]="!isGrid()" [location]="location"></app-location-card>
        </article>
      }
      <div [ngClass]="featuredLocation() ? 'col-lg-16 py-lg-4' : 'col-24'">
        <div class="row" [ngClass]="isGrid() ? 'gutter-y-5' : 'gutter-y-2'">
          @for (location of locations(); track location.id; let i = $index) {
            <article
              [ngClass]="locations().length === 1 ? 'col-sm-24 text-max-width-lg mx-auto' : 'col-sm-12'"
              class=""
              [class.pe-lg-4]="!isGrid()"
            >
              <app-location-card
                class="mx-lg-auto"
                [ngClass]="!isGrid() && location.id === 1 ? 'text-bg-primary' : ''"
                [class.card]="!isGrid()"
                [location]="location"
                [isBig]="locations().length === 1"
              ></app-location-card>
            </article>
          }
        </div>
      </div>
    </div>
  }
</section>
